// extracted by mini-css-extract-plugin
export default {"header-cell":"hpteRO","headerCell":"hpteRO","savings":"g_Ds2c","cta":"gKu2Hj","anonymous":"d25Fch","tax":"Rai3lk","sale":"iGyjiD"};